// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"page-wrapper_pageWrapper__39f0m","contentContainer":"page-wrapper_contentContainer__3QvfS"};